import * as Types from '../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SingleProjectRequestQueryVariables = Types.Exact<{
  requestId: Types.Scalars['String'];
}>;


export type SingleProjectRequestQuery = { __typename?: 'QueryModel', projectRequests?: { __typename?: 'ProjectRequestQueryModel', single?: { __typename?: 'ProjectRequest', name: string, clientContactName: string, state: Types.ProjectRequestState, statusMessage?: string | null, officeCode: string, city: string, section?: string | null, township?: string | null, block?: string | null, range?: string | null, budget?: number | null, survey?: string | null, projectInstructions?: string | null, officeInstructions?: string | null, fieldInstructions?: string | null, fieldContact?: string | null, fieldMeetInfo?: string | null, invoiceContact?: string | null, invoiceSubmitEmail?: string | null, additionalComments?: string | null, afe?: string | null, wo?: string | null, po?: string | null, costCenter?: string | null, contractNumber?: string | null, glCode?: string | null, requisitioner?: string | null, governmentFunding: Types.GovernmentFundingType, latitude?: number | null, longitude?: number | null, coGo?: string | null, taxableServices: boolean, jobsFolderRequired: boolean, jobsFolderDriveLetter?: string | null, requestId: string, rejectedReason?: string | null, scope: string, lastCheckoutTime?: any | null, certifiedPayroll: boolean, projectOrigination?: Types.ProjectOrigination | null, projectOriginationName?: string | null, projectManager?: { __typename?: 'Employee', firstName: string, middleInitial: string, lastName: string, userPrincipalName: string } | null, customer?: { __typename?: 'Customer', customerId: number, name: string, number?: string | null, address1: string, address2: string, phone: string, fax: string, zip: string, createCustomerRequestId: string, city: string, country: string, state: string, status: Types.CustomerStatus, attn?: string | null, requiresEogAfeType: boolean, adminNotes?: string | null, badDebtWriteOffs?: Array<{ __typename?: 'BadDebtWriteOff', date: string, amount: number } | null> | null } | null, serviceDescription?: { __typename?: 'ServiceDescription', displayName: string, industry: string, description: string, projectType: string, legacyWorkCode: string, isOverhead: boolean } | null, location?: { __typename?: 'StateCounty', state: string, county: string } | null, eogAfeType?: { __typename?: 'EogAfeType', gen: string, sub: string, description: string, afeType: string } | null, groupedFolder?: { __typename?: 'GroupedFolder', id: number, name: string, syncStatus: Types.SyncStatus } | null, approver?: { __typename?: 'Employee', firstName: string, middleInitial: string, lastName: string, userPrincipalName: string } | null, checkedOutBy?: { __typename?: 'Employee', firstName: string, middleInitial: string, lastName: string, userPrincipalName: string } | null } | null } | null };


export const SingleProjectRequestDocument = gql`
    query SingleProjectRequest($requestId: String!) {
  projectRequests {
    single(requestId: $requestId) {
      name
      clientContactName
      state
      statusMessage
      projectManager {
        firstName
        middleInitial
        lastName
        userPrincipalName
      }
      customer {
        customerId
        name
        number
        address1
        address2
        phone
        fax
        zip
        createCustomerRequestId
        city
        country
        state
        status
        attn
        requiresEogAfeType
        badDebtWriteOffs {
          date
          amount
        }
        adminNotes
      }
      serviceDescription {
        displayName
        industry
        description
        projectType
        legacyWorkCode
        isOverhead
      }
      officeCode
      location {
        state
        county
      }
      city
      section
      township
      block
      range
      budget
      survey
      projectInstructions
      officeInstructions
      fieldInstructions
      fieldContact
      fieldMeetInfo
      invoiceContact
      invoiceSubmitEmail
      additionalComments
      afe
      eogAfeType {
        gen
        sub
        description
        afeType
      }
      wo
      po
      costCenter
      contractNumber
      glCode
      requisitioner
      governmentFunding
      latitude
      longitude
      coGo
      taxableServices
      jobsFolderRequired
      jobsFolderDriveLetter
      groupedFolder {
        id
        name
        syncStatus
      }
      requestId
      rejectedReason
      scope
      approver {
        firstName
        middleInitial
        lastName
        userPrincipalName
      }
      lastCheckoutTime
      checkedOutBy {
        firstName
        middleInitial
        lastName
        userPrincipalName
      }
      certifiedPayroll
      projectOrigination
      projectOriginationName
    }
  }
}
    `;

/**
 * __useSingleProjectRequestQuery__
 *
 * To run a query within a React component, call `useSingleProjectRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleProjectRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleProjectRequestQuery({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useSingleProjectRequestQuery(baseOptions: Apollo.QueryHookOptions<SingleProjectRequestQuery, SingleProjectRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleProjectRequestQuery, SingleProjectRequestQueryVariables>(SingleProjectRequestDocument, options);
      }
export function useSingleProjectRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleProjectRequestQuery, SingleProjectRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleProjectRequestQuery, SingleProjectRequestQueryVariables>(SingleProjectRequestDocument, options);
        }
export type SingleProjectRequestQueryHookResult = ReturnType<typeof useSingleProjectRequestQuery>;
export type SingleProjectRequestLazyQueryHookResult = ReturnType<typeof useSingleProjectRequestLazyQuery>;
export type SingleProjectRequestQueryResult = Apollo.QueryResult<SingleProjectRequestQuery, SingleProjectRequestQueryVariables>;